import { render, staticRenderFns } from "./StudentLookup.vue?vue&type=template&id=0031d15a&"
import script from "./StudentLookup.vue?vue&type=script&lang=js&"
export * from "./StudentLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports